import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Chart from "react-google-charts";
import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

const styles = {
  card: {
    minWidth: 275,
    width: 'auto'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 18,
  },
  pos: {
    marginBottom: 12,
  },
};

function TideChart(props) {
  const { classes, waterLevel } = props; 
  const [ waterLevelData, setWaterLevelData ] = useState([]);

  let dates_arr = []
 
  const dataFormatting = () => {
        const FORECAST_DATETIME_INDEX = 0;
        const FORECAST_WAVE_HEIGHT_INDEX = 1;

        dates_arr = waterLevel.map((element, index) => {

          let today = new Date().getDate()
          var d = new Date(element[FORECAST_DATETIME_INDEX]);

          if (index===0)              
            return ["Element", "Water Level", { role: "style" }];
          else {
            if (d.getDate()===today) {

                let barColor = ''

                const OPACTICY='0.7'
                const FILL_COLOR='#3cbbe8'

                barColor = 'fill-color: lightblue; fill-opacity: 0.3'

                let now = new Date().getHours()

                if (d.getHours()===now)
                    barColor = 'fill-color: '+ 'red' + '; fill-opacity:'+ OPACTICY
                else
                    barColor = 'fill-color: '+ FILL_COLOR + '; fill-opacity:'+ OPACTICY

                return [new Date(d.getFullYear(),d.getMonth(),d.getDate(),d.getHours(),d.getMinutes(),d.getSeconds()),
                  + element[FORECAST_WAVE_HEIGHT_INDEX],
                  barColor];
              }
          }
        }).filter(e => e !== undefined)
  }

  useEffect(() => {
    dataFormatting();
    setWaterLevelData(dates_arr);
  }, [waterLevel])

    return (  
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title}>
          Tide (Today)
          </Typography>
            <div className="App">
            {(waterLevelData.length > 0) ? (
                  <Chart
                    chartType="ColumnChart"
                    height="200px"
                    data={waterLevelData}
                    options={
                        {title: "Height in feet MLLW", 
                        subtitle: "Subtitle here...",
                        legend: { position: "none" },
                        chartArea:{left:30,top:20,width:'95%',height:'80%'},
                        hAxis: {
                          gridlines: {count: 5},
                        },
                        gridlines: {
                          units: {
                            years: {format: [/*format strings here*/]},
                            months: {format: [/*format strings here*/]},
                            days: {format: ['d']},
                            hours: {format: ['h']},
                            minutes: {format: [/*format strings here*/]},
                            seconds: {format: [/*format strings here*/]},
                            milliseconds: {format: [/*format strings here*/]},
                          }
                        }
                      }
                    }
                  />
               ) : (
                <div>
                    <Skeleton variant="rectangular" width={'100%'} height={200} />
                </div>
              )}
            </div>
        </CardContent>
      </Card>
  );
}

TideChart.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TideChart);


